export default "__VITE_ASSET__jD9eW1F8__"